import {
  UnitActiveDetailsManagementForm,
  UnitCancelledDetailsManagementForm
} from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management'
import { AppType } from '@apps-common/config/app-types'
import { UNIT_STATUS_ACTIVE, UNIT_STATUS_CANCELLED, UNIT_STATUS_INACTIVE } from '@apps-common/config/unit-filter'
import { invalidateAllUnitQueries } from '@apps-common/helpers/invalidate-unit-queries'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

interface IProps {
  loading: boolean
  unit?: IUnitGenericDetailsModel
}

export const UnitDetailsManagement: React.FC<IProps> = ({ loading, unit }) => {
  const { navigateBack } = useNavigation()
  const { unitId, status } = unit || {}

  return (
    <>
      {(!status || status === UNIT_STATUS_ACTIVE.value || status === UNIT_STATUS_INACTIVE.value) && (
        <UnitActiveDetailsManagementForm
          unitId={unitId}
          doneCallback={() => {
            invalidateAllUnitQueries(unitId || '', AppType.management)
            navigateBack()
          }}
        />
      )}
      {status === UNIT_STATUS_CANCELLED.value && <UnitCancelledDetailsManagementForm unitId={unitId} />}
    </>
  )
}
